/*
	This is a thin wrapper around Rhombus's Modal to remove some of our common boilerplate
	configuring it to be a modal, instead of a blade, etc., and overriding some of its
	default styling so that it contains ProgressIndicators properly, etc.

	There are also common issues with setting up modals to have scrolling content that doesn't
	overflow the viewport, etc., which can be consolidated.

	Ideally, you shouldn't have to specify anything but what's specific to your modal,
	like the title, renderContent and renderFooter.

	To keep it as simple as possible, we don't try to do any merging of modal props with defaults.
	If you want to take advantage of the default styling, just include "basic-modal" if you pass
	in a `className` prop.  Any prop you specify will override these defaults.

	i.e.
	```
		<BasicModal className="basic-modal more-specific-modal" ... />
	```

	For correct positioning and scrolling of the modal content, you can wrap it in a <ProgressContainer>.

	e.g.
	```
		function SpecificModal(props){
			const isLoading = useSelector(...);
			const modalProps = {
				renderContent(){
					return (
						<ProgressContainer isLoading={isLoading}>
							<div>Whatever modal content</div>
						</ProgressContainer>
					);
				}
			}
			return <BasicModal {...modalProps} />;
		}
	```
*/

import React from "react";
import { Modal } from "rhombus-react";
import { noop } from "utils/common";

import "./BasicModal.css";

export const BASIC_MODAL_PROPS = {
	title: "",
	setAppTitle: false,
	type: "modal",
	className: "basic-modal",
	xClose: true,
	allowFullScreen: false,
	bladeProps: {
		verticallyCenter: true,
	},
	renderContent: () => null,
	renderFooter: () => null,
	onClose: noop,
};

export default function BasicModal(props){
	return (
		<Modal
			{...BASIC_MODAL_PROPS}
			{...props}
		/>
	);
}

BasicModal.displayName = "BasicModal";
